import { StyleSheet, Text, View, ViewProps } from 'react-native'

import { Icon } from '../../icons'
import { tokens } from '../../theme/tokens'

export interface DelayAlertProps extends ViewProps {
  /** Heading line. Pass a translated string. */
  title: string
  /** Body copy. Pass a translated string. */
  description: string
}

/**
 * Warning banner for area-wide delivery delays.
 *
 * Consolidates the near-verbatim `Alert` duplicates in CWA and CMA. Copy is
 * supplied by the caller (through each app's i18n layer) — this component
 * owns only the presentation.
 */
export const DelayAlert = ({ title, description, style, ...passthroughProps }: DelayAlertProps) => {
  return (
    <View accessibilityRole="alert" {...passthroughProps} style={[styles.container, style]}>
      <View style={styles.iconColumn}>
        <Icon name="warning" size={24} />
      </View>
      <View style={styles.textColumn}>
        <Text style={styles.title}>{title}</Text>
        <Text style={styles.description}>{description}</Text>
      </View>
    </View>
  )
}

DelayAlert.displayName = 'DelayAlert'

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    backgroundColor: tokens.colors.brand.lightGrey,
    borderWidth: 1,
    borderColor: tokens.colors.brand.textPlaceholder,
    borderRadius: 8,
    padding: 8,
  },
  iconColumn: {
    paddingTop: 10,
    paddingHorizontal: 8,
  },
  textColumn: {
    flex: 1,
    padding: 8,
  },
  title: {
    fontSize: 18,
    fontWeight: 'bold',
    color: tokens.colors.brand.textSoftBlack,
  },
  description: {
    fontSize: 12,
    color: tokens.colors.brand.textSoftBlack,
  },
})
